import type { CityConfig } from "../city-template/types";

export const bellevilleConfig: CityConfig = {
  city: "Belleville",
  state: "Illinois",
  stateAbbr: "IL",
  slug: "belleville",
  route: "/cities/belleville",
  title: "Emergency Passport Belleville, IL — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Belleville, Illinois — as fast as 24 hours. Fast passport renewal for Scott AFB personnel, SWIC students, and all St. Clair County residents in the Metro East. A+ BBB rated registered State Dept. courier serving Metro East Illinois.",
  h1: "Emergency & Expedited Passport Services in Belleville, IL",
  heroSubtitle: "Scott AFB deployment orders in 5 days and your passport expired? SWIC study abroad to Germany and forgot to renew? Longest Main Street in America doesn't help when you need a passport overnight. We help Belleville residents get their passports fast — as fast as 24 hours. A+ BBB rated registered State Dept. courier serving St. Clair County and the entire Metro East.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Belleville%20Illinois%20historic%20downtown%20featuring%20Main%20Street%20with%20charming%20brick%20storefronts%20and%20vintage%20lampposts%2C%20the%20iconic%20Belleville%20fountain%20in%20the%20town%20square%2C%20tree%20lined%20streets%20in%20a%20classic%20Midwest%20small%20city%2C%20St%20Clair%20County%20courthouse%20bell%20tower%20in%20the%20distance%2C%20warm%20golden%20hour%20sunlight%2C%20professional%20landscape%20photography%2C%20inviting%20Illinois%20Metro%20East%20community%20atmosphere%2C%20autumn%20foliage%20colors&width=1800&height=700&seq=belleville-hero-001&orientation=landscape",
  heroImageAlt: "Belleville Illinois historic downtown on Main Street at golden hour with the town square fountain",
  geoPosition: "38.5201;-89.9838",
  geoPlacename: "Belleville, Illinois",
  lastModified: "2026-06-04",
  regionalAgency: {
    name: "Chicago Passport Agency",
    address: "230 S Dearborn St, Suite 380, Chicago, IL 60604",
    distance: "Approximately 4 hours 30 minutes northeast of Belleville via I-55",
  },
  nearbyCitiesZips: [
    { name: "Belleville", zips: "62220, 62221, 62223, 62226" },
    { name: "O'Fallon", zips: "62269" },
    { name: "Fairview Heights", zips: "62208" },
    { name: "Swansea", zips: "62226" },
    { name: "Shiloh", zips: "62269" },
    { name: "Collinsville", zips: "62234" },
    { name: "Mascoutah", zips: "62258" },
    { name: "Freeburg", zips: "62243" },
    { name: "Millstadt", zips: "62260" },
    { name: "Waterloo", zips: "62298" },
    { name: "Columbia", zips: "62236" },
    { name: "Cahokia", zips: "62206" },
    { name: "Lebanon", zips: "62254" },
    { name: "Highland", zips: "62249" },
    { name: "St. Louis, MO", zips: "63101, 63102, 63103" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier to Chicago Passport Agency — 4.5 hours away but you skip the trip entirely" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting for Metro East travelers" },
    { icon: "ri-plane-line", title: "Scott AFB Hub", desc: "Serving Scott Air Force Base personnel, dependents, and DoD civilians with deployment and PCS travel needs" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Ship from any UPS or FedEx in Belleville — no 9-hour Chicago round trip required" },
  ],
  internalLinks: [
    { name: "Expedited passport in St. Louis, MO", route: "/cities/st-louis" },
    { name: "Emergency passport help in Springfield, IL", route: "/springfield-il" },
    { name: "Urgent passport services in Carbondale, IL", route: "/cities/carbondale" },
    { name: "Illinois passport services overview", route: "/states/illinois" },
  ],
  fpcOfficeAddress: "230 S Dearborn St, Suite 380, Chicago, IL 60604",
  fpcOfficeNote: "Fast Passport Center serves Belleville, Illinois remotely via secure registered courier. Our registered couriers hand-deliver your documents to the Chicago Passport Agency (4 hours 30 minutes northeast via I-55) — without you making the trip. Belleville residents can ship from any UPS or FedEx in St. Clair County. For Metro East travelers, our courier service eliminates an entire day of driving to Chicago.",
  fpcOfficeDistance: "Serving Belleville, O'Fallon, Fairview Heights, Swansea, Shiloh, Collinsville, Mascoutah, Freeburg, Millstadt, Waterloo, Columbia, Cahokia, Lebanon, Highland, St. Louis MO, and all of St. Clair County",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Belleville and the entire Metro East. From the historic Belleville Main Street and Scott AFB to the growing communities of O'Fallon and Shiloh, from the shopping districts of Fairview Heights to the German-heritage towns of St. Clair County — we serve the entire Illinois side of the St. Louis metropolitan area.",
  nearbyCitiesIntro: "We serve Belleville and all nearby communities including O'Fallon, Fairview Heights, Swansea, Shiloh, Collinsville, Mascoutah, Freeburg, Millstadt, Waterloo, Columbia, and Cahokia. We also serve St. Louis, Missouri and the entire Metro East region.",
  howItWorksIntro: "Most Belleville travelers complete everything online and ship documents overnight. No need to drive 4+ hours to Chicago — our couriers handle the Chicago Passport Agency trip for you. For Metro East residents, this is the smart alternative to an all-day Chicago drive.",
  mistakesIntro: "Belleville is home to Scott AFB, one of the most critical military installations in the country, with thousands of active-duty personnel requiring passports for deployments, PCS moves, and leisure travel — yet the nearest passport agency is 4+ hours away. Here are the most common passport mistakes in the Metro East.",
  testimonialsIntro: "Belleville travelers — from Scott AFB personnel with deployment orders and SWIC students heading abroad to Metro East families planning European vacations — trust us when their departure is days away.",
  faqIntro: "Have questions about expedited passports in Belleville, IL? Here are the most common ones we hear from Metro East travelers.",
  statePageRoute: "/states/illinois",
  statePageName: "Illinois",
  dmvWebsite: "https://www.ilsos.gov/facilities/facilitylist.html",
  dmvLabel: "Illinois Secretary of State — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Chicago Passport Agency — hand-delivered", "No 9-hour round trip to Chicago required", "Perfect for Scott AFB deployment timelines", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Chicago Passport Agency — hand-delivered", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "9+ hour round trip drive to Chicago", "Effectively impractical for most Metro East residents"],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Belleville travelers with immediate departure needs — as fast as 24 hours. Essential for Scott AFB deployment orders and Metro East last-minute travelers.",
      bullets: ["24–48 hour turnaround available", "Chicago Passport Agency direct courier", "No 9-hour Chicago round trip — ship locally"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Belleville adults with a passport issued within the last 15 years. Skip the post office appointment entirely.",
      bullets: ["No clerk visit required for most renewals", "Mail-in or courier options", "Returned to your Belleville address"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for Belleville residents — including Scott AFB dependents, new citizens, and Metro East families.",
      bullets: ["Acceptance facility scheduling", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for Belleville residents who lost their passport before international travel or military deployment.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for Belleville and St. Clair County families with kids traveling internationally.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for Belleville and St. Clair County residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-bank-card-line",
      title: "Passport Card",
      description: "Wallet-sized passport card for Belleville residents who need land/sea travel to Canada or Mexico — ideal for quick border crossings.",
      bullets: ["Land and sea travel to Canada, Mexico, Caribbean", "Wallet-sized convenience", "REAL ID compliant"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
    {
      icon: "ri-error-warning-line",
      title: "Damaged Passport",
      description: "Passport replacement for Belleville residents with water-damaged, torn, or otherwise damaged passports that need urgent replacement.",
      bullets: ["DS-11 form with damage explanation", "Photo verification for identity matching", "Emergency replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-file-copy-line",
      title: "Second Passport",
      description: "Second valid passport book for Belleville business travelers and frequent international flyers who need a backup while one is with an embassy.",
      bullets: ["Second valid passport book", "Ideal for frequent business travelers", "Keep traveling while visa processes"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Belleville IL", description: "Urgent passport processing for Belleville Illinois travelers and Scott AFB personnel with immediate departure needs." },
    { name: "Expedited Passport Renewal Belleville IL", description: "Fast passport renewal for Belleville Illinois residents and Metro East travelers." },
    { name: "First-Time Passport Belleville IL", description: "New passport application services for Belleville Illinois residents." },
    { name: "Child Passport Belleville IL", description: "Minor passport services for Belleville Illinois families with children under 16." },
  ],
  testimonials: [
    {
      name: "Capt. Marcus T.",
      location: "Belleville, IL — Scott AFB",
      rating: 5,
      text: "Deployment orders with 6 days notice and my passport had expired. Fast Passport Center got me a new one in 3 days. Shipped from the UPS on Carlyle Avenue. Made my deployment on time. Every active duty service member in the Metro East needs to know about this service.",
      service: "Passport Renewal",
    },
    {
      name: "Lisa R.",
      location: "Belleville, IL",
      rating: 5,
      text: "Family trip to Italy and realized my daughter's passport expired a month ago. Fast Passport Center walked me through the whole child passport process and we had it in 4 days. The O'Fallon post office appointment was a breeze. Saved our whole family vacation.",
      service: "Child Passport",
    },
    {
      name: "David M.",
      location: "Fairview Heights, IL",
      rating: 5,
      text: "Business trip to London came up with 8 days notice. My passport was set to expire in 2 months — not enough for UK entry. Fast Passport Center renewed it in 3 days. I shipped from Fairview Heights and had it back before my flight. Metro East business travelers, this is the way.",
      service: "Emergency Passport",
    },
  ],
  facilities: [
    {
      id: "blv-1",
      name: "Belleville Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "120 W Washington St",
      city: "Belleville",
      state: "IL",
      zip: "62220",
      phone: "(618) 233-3581",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Belleville, Downtown near Main Street",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Belleville acceptance facility. Convenient to downtown Belleville and near the historic district. Appointments strongly recommended. Full passport photo services available.",
      icon: "ri-mail-line",
    },
    {
      id: "blv-2",
      name: "St. Clair County Circuit Clerk",
      type: "County Clerk Passport Acceptance",
      address: "10 Public Square",
      city: "Belleville",
      state: "IL",
      zip: "62220",
      phone: "(618) 277-6600",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "Belleville, St. Clair County Courthouse at Public Square",
      website: "https://www.co.st-clair.il.us/",
      websiteLabel: "St. Clair County Circuit Clerk",
      notes: "St. Clair County acceptance facility in the historic courthouse at Belleville Public Square. County seat location. Call ahead to confirm passport acceptance hours.",
      icon: "ri-government-line",
    },
    {
      id: "blv-3",
      name: "O'Fallon Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1111 S Lincoln Ave",
      city: "O'Fallon",
      state: "IL",
      zip: "62269",
      phone: "(618) 632-4215",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "O'Fallon, approximately 6 miles northeast of Belleville",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for O'Fallon and Shiloh residents. Good alternative to Belleville post office with generally shorter wait times.",
      icon: "ri-mail-line",
    },
    {
      id: "blv-4",
      name: "Fairview Heights Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "9775 Fairview Ave",
      city: "Fairview Heights",
      state: "IL",
      zip: "62208",
      phone: "(618) 397-5307",
      hours: "Mon–Fri: 9:00 AM – 5:00 PM",
      distance: "Fairview Heights, approximately 7 miles north of Belleville",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Fairview Heights and northern St. Clair County. Near St. Clair Square shopping mall. Extended hours until 5 PM.",
      icon: "ri-mail-line",
    },
    {
      id: "blv-5",
      name: "Collinsville Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "130 S Center St",
      city: "Collinsville",
      state: "IL",
      zip: "62234",
      phone: "(618) 344-1701",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Collinsville, approximately 12 miles northeast of Belleville",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Collinsville and northeastern St. Clair County. Home of the World's Largest Catsup Bottle. Convenient for I-55/70 travelers.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, 2–3 week wait", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 4.5 hour drive to Chicago", fpc: "No — ship from Belleville" },
    { feature: "Time Commitment", agency: "9+ hour round trip — full day lost", fpc: "Minutes — ship from your neighborhood" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Practical for Metro East", agency: "No — an entire day investment", fpc: "Yes — the smart fast solution" },
  ],
  mistakes: [
    {
      icon: "ri-calendar-close-line",
      title: "Scott AFB Deployment Deadlines",
      description: "Scott AFB personnel frequently get deployment orders with tight timelines and expired or expiring passports. Military no-fee passports are for official travel only — personal leisure travel requires a tourist passport. Our service handles both scenarios.",
    },
    {
      icon: "ri-road-map-line",
      title: "Unnecessary Chicago Drive",
      description: "Many Metro East travelers assume they can 'just drive to Chicago' for an emergency appointment. At 4.5 hours each way plus downtown Chicago navigation and wait times, this is a 9+ hour ordeal — a full day lost that most people simply can't spare.",
    },
    {
      icon: "ri-passport-line",
      title: "Six-Month Validity Rule Overlooked",
      description: "Many Metro East international travelers don't know that numerous countries require 6 months of passport validity beyond the return date. A passport valid for 4 months is effectively expired for most European and Asian destinations.",
    },
    {
      icon: "ri-image-line",
      title: "Military Photo Standards Confusion",
      description: "Scott AFB ID photos do not meet Department of State passport photo standards. The lighting, background, and sizing requirements are different and strict. Always use a dedicated passport photo service.",
    },
    {
      icon: "ri-file-list-line",
      title: "Wrong Application Form",
      description: "Using DS-82 instead of DS-11 for first-time passports (or vice versa) is the #1 cause of rejection at Belleville and O'Fallon acceptance facilities. Our document review catches this before submission.",
    },
    {
      icon: "ri-global-line",
      title: "PCS International Moves Confusion",
      description: "Scott AFB families with PCS orders overseas often confuse the military no-fee passport process with tourist passport requirements. Both may be needed — the no-fee for official orders, a tourist passport for personal travel while stationed abroad.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from anywhere in Belleville or St. Clair County." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS or FedEx near Main Street or Carlyle Avenue." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document — experienced with military deployments, SWIC study abroad, and Metro East business travel." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Our registered courier submits to the Chicago Passport Agency — 4+ hours away but you never make the trip." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Belleville address — trackable every step of the way." },
  ],
  faqs: [
    { q: "How fast can I get an emergency passport in Belleville, IL?", a: "Fast Passport Center offers emergency passport processing in Belleville, Illinois in as little as 24–48 hours. Our registered couriers hand-deliver your documents to the Chicago Passport Agency (4 hours 30 minutes northeast via I-55) — without you making the trip. For Metro East residents, this eliminates an entire day of driving." },
    { q: "Does Belleville have a passport agency?", a: "No — Belleville does not have a regional passport agency. The nearest facility is the Chicago Passport Agency approximately 4 hours 30 minutes northeast via I-55. St. Louis also has a passport agency approximately 25 minutes west. Fast Passport Center's courier service is the most practical fast option for Metro East travelers." },
    { q: "Can Scott AFB personnel use your passport services?", a: "Absolutely. Fast Passport Center serves Scott Air Force Base active-duty personnel, dependents, DoD civilians, and contractors. We understand deployment timelines, PCS schedules, and the unique passport needs of the military community. Our expedited service is ideal for short-notice travel requirements." },
    { q: "What airport do Belleville travelers use for international flights?", a: "Most Belleville travelers use St. Louis Lambert International Airport (STL) — approximately 30 minutes northwest via I-64. STL offers comprehensive domestic connections and international flights. Chicago O'Hare (ORD) is approximately 4 hours 30 minutes northeast, typically used only when STL doesn't have the route." },
    { q: "Do you serve O'Fallon, Fairview Heights, and Metro East communities?", a: "Yes — Fast Passport Center serves all of St. Clair County and the Metro East including Belleville, O'Fallon, Fairview Heights, Swansea, Shiloh, Collinsville, Mascoutah, Freeburg, Millstadt, Waterloo, Columbia, Cahokia, Lebanon, and Highland. We also serve St. Louis, Missouri." },
    { q: "Can I get my child's passport expedited in Belleville?", a: "Yes. Fast Passport Center expedites child passports in Belleville for minors under 16. Both parents must appear or submit notarized consent. We guide Metro East families through the entire DS-11 process for minors." },
    { q: "Where can I get passport photos in Belleville?", a: "Walgreens on Carlyle Avenue, CVS on West Main Street, and the UPS Store on Frank Scott Parkway all offer passport photos. The Belleville Post Office also provides photo services during business hours. Photos must be 2x2 inches on a white background." },
    { q: "Is there really no other fast option in the Metro East?", a: "Honestly — no. The Chicago Passport Agency at 230 S Dearborn St, Suite 380, Chicago, IL 60604 is approximately 290 miles (4+ hours) away and requires appointments booked weeks in advance for non-emergencies. For regular urgent travel, Fast Passport Center's courier service is the most practical 24–48 hour option in the Metro East. It's why we're so popular with Scott AFB and the St. Clair County community." },
  ],
  photoLocations: [
    { name: "Walgreens — Belleville", address: "120 Carlyle Ave, Belleville, IL 62221", hours: "Mon–Sun: 7AM–10PM", website: "https://www.walgreens.com/" },
    { name: "UPS Store — Belleville", address: "5601 Belleville Crossing St, Belleville, IL 62226", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM", website: "https://www.theupsstore.com/" },
    { name: "CVS — Belleville", address: "1000 W Main St, Belleville, IL 62220", hours: "Mon–Sun: 8AM–9PM", website: "https://www.cvs.com/" },
    { name: "Walgreens — Fairview Heights", address: "10850 Lincoln Trail, Fairview Heights, IL 62208", hours: "Mon–Sun: 7AM–10PM", website: "https://www.walgreens.com/" },
  ],
  dmvLocations: [
    { name: "Illinois SOS — Belleville", address: "400 W Main St, Belleville, IL 62220", hours: "Mon–Fri: 8:00AM–5:00PM", note: "Illinois Secretary of State for driver's licenses, REAL ID, and vehicle registration. Downtown Belleville near the courthouse. Online reservations strongly recommended.", featured: true },
    { name: "Illinois SOS — Fairview Heights", address: "15 Executive Dr, Fairview Heights, IL 62208", hours: "Mon–Fri: 8:00AM–5:00PM", note: "Serves Fairview Heights and northern St. Clair County. REAL ID processing available. Good alternative with generally shorter wait times.", featured: false },
  ],
  vitalRecordsIcon: "ri-heart-pulse-line",
  vitalRecordsLinks: [
    { label: "Birth & Death Certificates (IDPH)", url: "https://dph.illinois.gov/topics-services/birth-death-other-records.html", desc: "Illinois Department of Public Health — Division of Vital Records for St. Clair County birth and death certificates" },
    { label: "Marriage Licenses (St. Clair County Clerk)", url: "https://www.co.st-clair.il.us/departments/county-clerk", desc: "St. Clair County Clerk — marriage license applications and certified copies for Belleville and Metro East" },
    { label: "Divorce Decrees (St. Clair County Circuit Clerk)", url: "https://www.co.st-clair.il.us/departments/circuit-clerk", desc: "St. Clair County Circuit Clerk — divorce decree records for Belleville and St. Clair County residents" },
    { label: "VitalChek Online Ordering", url: "https://www.vitalchek.com/", desc: "Order Illinois birth, death, marriage, and divorce certificates online via VitalChek — fastest state-approved method" },
  ],
  airports: [
    {
      code: "STL",
      name: "St. Louis Lambert International Airport",
      distance: "Approximately 30 minutes northwest of Belleville via I-64",
      address: "10701 Lambert International Blvd, St. Louis, MO 63145",
      note: "Primary international airport for Belleville and the entire Metro East. Southwest Airlines hub with domestic connections and international flights. The closest major airport — about 30 minutes from Belleville.",
      flightUrl: "https://www.flystl.com/",
      flightLabel: "STL Flight Info",
      featured: true,
    },
    {
      code: "ORD",
      name: "Chicago O'Hare International Airport",
      distance: "Approximately 4 hours 30 minutes northeast via I-55",
      address: "10000 W O'Hare Ave, Chicago, IL 60666",
      note: "Major international hub with extensive global connections. Used when STL doesn't have the specific international route needed. About 4.5 hours from Belleville — a full-day trip.",
      flightUrl: "https://www.flychicago.com/ohare/",
      flightLabel: "ORD Flight Info",
      featured: false,
    },
    {
      code: "BLV",
      name: "MidAmerica St. Louis Airport",
      distance: "Approximately 15 minutes east of Belleville via I-64",
      address: "9656 Air Terminal Dr, Mascoutah, IL 62258",
      note: "Regional airport adjacent to Scott AFB with Allegiant Air flights. Convenient for domestic leisure travel but limited international options. About 15 minutes from Belleville.",
      flightUrl: "https://www.flymidamerica.com/",
      flightLabel: "BLV Flight Info",
      featured: false,
    },
  ],
};